module.exports = __webpack_public_path__ + "static/media/icon_world_experts.6f9f98df.svg";